<template>
    <div>

        <!-- Table -->
        <tq-table
                class="TQ_margin_8px"
                :rows="p_questTickets_ac"
                :system-lang-code="p_system_langCode_e"
                :display-search="true"
                p_td-classes_s="TQ_padding_4px"
                p_td-classes-actions_s="TQ_width_300px"
                :columns="[
                        { label : ass_strings.oneWord_date[p_system_langCode_e],            class_s: (row) => {return 'TQ_direction_ltr'},                              field : (row) => {return format_date_YYYY_MM_DD_fs(row.qt_saleDate_t)}},
                        { label : ass_strings.twoWords_boughtBy[p_system_langCode_e],       class_s: (row) => {return ''},                                              field : (row) => {return p_usersData_byUserId_c[row.qt_playerId_uid] ? p_usersData_byUserId_c[row.qt_playerId_uid].ud_name_s : ''}, avatar_c : (row) => {return this.m_dom_getAvatar_s(row.qt_playerId_uid)}},
                        { label : ass_strings.oneWord_email[p_system_langCode_e],           class_s: (row) => {return ''},                                              field : (row) => {return p_usersData_byUserId_c[row.qt_playerId_uid] ? p_usersData_byUserId_c[row.qt_playerId_uid].ud_email_s : ''}},
                        { label : ass_strings.oneWord_cost[p_system_langCode_e],            class_s: (row) => {return 'TQ_direction_ltr'},                              field : (row) => {return format_cost_s(row.qt_cost_c, row.qt_discountPercentage_n)}},
                        { label : ass_strings.oneWord_discount[p_system_langCode_e],        class_s: (row) => {return 'TQ_direction_ltr'},                              field : (row) => {return row.qt_discountPercentage_n + '%'}},
                        { label : ass_strings.twoWords_agentId[p_system_langCode_e],        class_s: (row) => {return 'TQ_direction_ltr'},                              field : (row) => {return row.qt_agentId_uid}},
                        { label : ass_strings.oneWord_text[p_system_langCode_e],            class_s: (row) => {return ''},                                              field : (row) => {return row.qt_creatorText_s}},
                        { label : ass_strings.twoWords_joinedPlayers[p_system_langCode_e],  class_s: (row) => {return 'TQ_direction_ltr'},                              field : (row) => {return `${obj_size_fn(row.qt_playersJoinDate_byUserId_t)}/${row.qt_spots_n}`}},
                        { label : ass_strings.oneWord_status[p_system_langCode_e],          class_s: (row) => {return helper_getTicketStatusClass_fs(row.qt_status_e)}, field : (row) => {return format_ticketStatus_fs(row.qt_status_e, p_system_langCode_e)}},
                        { label : ass_strings.twoWords_entryCode[p_system_langCode_e],      class_s: (row) => {return 'TQ_direction_ltr TQ_text_24px'},                 field : (row) => {return row.qt_shortKeyId_s}},
                ]"
                :p_actions_ao="[
                            { display : m_dom_displayCancelBtn_fb,                      img_r: ass_img_xLetter_w,   label_byLangCode : ass_strings.oneWord_cancel,          popupText_byLangCode: ass_strings.question_cancelTicketMsg, action_f : m_userEvent_cancelTicket,        class : 'TQ_bg_red'    },
                            { display : m_dom_displayApprovedBtn_fb,                    img_r: ass_img_checked_w,   label_byLangCode : ass_strings.oneWord_approve,         popupText_byLangCode: ass_strings.question_approveTicket,   action_f : m_userEvent_approveTicket,       class : 'TQ_bg_green'  },
                            { display : m_dom_displayEditBtn_fb,                        img_r: ass_img_edit_w,      label_byLangCode : ass_strings.oneWord_edit,            popupText_byLangCode: null,                                 action_f : m_userEvent_editTicket,          class : 'TQ_bg_gray1 TQ_textColor_white'  },

                            { display : (qt) => {return true},                          img_r: ass_img_link_w,      label_byLangCode : ass_strings.oneWord_Link,       popupText_byLangCode: null,                                 action_f : m_userEvent_copyWebTicketUrl,    class : 'TQ_bg_gold TQ_textColor_white'   },
                            { display : (qt) => {return qt.qt_receiptLink_s != null},                               label_byLangCode : ass_strings.oneWord_receipt,         popupText_byLangCode: null,                                 action_f : m_userEvent_openReceipt_f,       class : 'TQ_bg_gray4'   },
                        ]"
        />
        
        <!-- btns -->
        <div class="TQ_padding_8px TQ_align_end TQ_border_top">

            <!-- link to media -->
            <div class="TQ_inline">

            <div class="TQ_bg_gray1 TQ_inline TQ_box_shadow TQ_borderRadius TQ_textColor_white TQ_padding_4px TQ_clickable "
                :data-hook="DataHooks_o.page_creator_event_item_media_button"
                @click="m_openMediaInAnewTab_f">
                <tq-image :pb_src_r="ass_svg_photo_w" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_4px"/>
                <div class="TQ_verticalAlignMiddle TQ_inline TQ_padding_4px">
                    {{ass_strings.twoWords_mediaLink[p_system_langCode_e]}}
                </div>
            </div>
            </div>

            <!-- space-->
            <div class="TQ_padding_4px TQ_inline"></div>


            <!-- link to store for specific event -->
            <div class="TQ_inline">

                <div class="TQ_bg_gold TQ_inline TQ_box_shadow TQ_borderRadius TQ_textColor_white TQ_padding_4px TQ_clickable "
                     @click="popup_showStoreLink_vb.val=true">
                    <tq-image :pb_src_r="ass_img_link_w" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_4px"/>
                    <div class="TQ_verticalAlignMiddle TQ_inline TQ_padding_4px">
                        {{ass_strings.twoWords_storeLink[p_system_langCode_e]}}
                    </div>
                </div>
            </div>

            <!-- space-->
            <div class="TQ_padding_4px TQ_inline"></div>

            <!-- create ticket -->
            <div @click="m_userEvent_showPopup_requestNewTicket_f"
                 class="TQ_bg_green TQ_borderRadius TQ_inline TQ_padding_4px TQ_clickable TQ_box_shadow">
                <tq-image :pb_src_r="ass_img_ticket_w" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_4px"/>
                <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px">
                    {{ass_strings.twoWords_newTicket[p_system_langCode_e]}}
                </div>
            </div>
        </div>

        <!-- popup | edit ticket popup  -->
        <tq-popup :show="editTicketPopup_o.showPopup_vb"
                  class="TQ_center"
                  :show-close-btn="true"
                  width="100%" padding="0" maxWidth="500px">

            <!-- title -->
            <div class="TQ_text_20px TQ_padding_8px TQ_border_bottom TQ_text_capitalize TQ_margin_bottom_8px">
                {{
                    editTicketPopup_o.editTicket_c ?
                        ass_strings.twoWords_editEvent[p_system_langCode_e] :
                        ass_strings.fourWords_createNewEntryTicket[p_system_langCode_e]
                }}
            </div>

            <!-- body -->
            <div class="TQ_padding_8px TQ_maxWidth_400px TQ_center">

                <!-- player num and cost-->
                <div class="TQ_grid_col_autoAuto TQ_grid_gap_8px">

                    <!-- players -->
                    <div class="TQ_inline TQ_verticalAlignTop TQ_margin_bottom_8px">

                        <div class="TQ_align_initial">
                            <div class="TQ_textAlign_initial TQ_text_16px">{{ass_strings.oneWord_spots[p_system_langCode_e]}}</div>

                            <fc-error-input
                                class="TQ_maxWidth_200px"
                                p_input-class_s="TQ_center TQ_padding_6px"
                                :p_input-type_s="enum_inputType.number_s"
                                :p_val_o="editTicketPopup_o.spots_n"
                                :p_min_n="0"
                                :p_more-info-id_e="enum_moreInfoIds_s.helpers_event_store_link"
                                :p_error_s="co_editTicket_error_slots_s"
                                :pe_input_f="val => editTicketPopup_o.spots_n = val"
                            />

                            <div class="TQ_align_initial TQ_text_12px">
                                [0,{{co_totalAvailableTickets_n}}]
                            </div>
                       </div>

                    </div>

                    <!-- cost -->
                    <div class="TQ_inline TQ_verticalAlignTop TQ_margin_bottom_8px">
                        <div class="TQ_textAlign_initial TQ_text_16px">{{ass_strings.oneWord_price[p_system_langCode_e]}}</div>

                        <div class="TQ_grid_col_1frAuto TQ_borderBox">

                            <fc-error-input
                                class="TQ_inline TQ_verticalAlignTop TQ_width_100p"
                                p_input-class_s="TQ_center TQ_padding_6px TQ_width_100p"
                                :p_input-type_s="enum_inputType.number_s"
                                :p_val_o="editTicketPopup_o.cost_c.c_value_n"
                                :p_min_n="0"
                                :p_error_s="co_editTicket_error_cost_s"

                                :pe_input_f="val => editTicketPopup_o.cost_c.c_value_n = val"
                            />


                            <tq-dropdown class="TQ_border_bottom_gray  TQ_width_52px TQ_verticalAlignTop" :style-select="true">
                                <div slot="select" class="TQ_padding_1px" >
                                    {{ format_costCurrency(editTicketPopup_o.cost_c.c_currency_e) }}
                                </div>

                                <div slot="options"
                                     class="TQ_border_bottom TQ_padding_4px "
                                     @click="editTicketPopup_o.cost_c.c_currency_e = currency"
                                     v-for="currency in enum_costCurrency"
                                     :key="currency">
                                    {{format_costCurrency(currency)}}
                                </div>
                            </tq-dropdown>
                        </div>




                    </div>
                </div>

                <!-- text -->
                <div class=" TQ_center">
                    <tq-textarea
                            pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px "
                            :pb_init-text_s="editTicketPopup_o.text_s"
                            :pb_max-length_n="80"
                            :pb_placeholder_s="ass_strings.twoWords_moreInfo[p_system_langCode_e]"
                            :pb_rows_n="2"
                            :pe_change-text_s="(text_s) => {editTicketPopup_o.text_s = text_s}"
                    />

                </div>

            </div>

            <!-- bottom btns-->
            <div class="TQ_align_end TQ_padding_12px TQ_border_top">


                <tq-loader-button :show-loader="editTicketPopup_o.showLoader_b">
                    <div :class="co_editTicket_error_cost_s || co_editTicket_error_slots_s ? 'TQ_bg_gray12' : 'TQ_bg_purple'"
                         class="TQ_padding_8px TQ_center TQ_box_shadow TQ_borderRadius TQ_clickable TQ_width_100px"
                         @click="m_userEvent_approveEditTicket_f">
                        {{ass_strings.oneWord_approve[p_system_langCode_e]}}
                    </div>
                </tq-loader-button>

            </div>

        </tq-popup>

        <!-- popup | event store-->
        <tq-popup :show="popup_showStoreLink_vb" max-width="500px" padding="0px" :show-close-btn="true" class="TQ_bg_white">

            <div class="TQ_bg_purple_dark TQ_padding_12px TQ_margin_bottom_8px TQ_text_20px TQ_grid_col_Auto1frAuto">
                <div class="TQ_width_24px TQ_grid_center"></div>
                <div class="TQ_grid_center">
                    {{ass_strings.twoWords_storeLink[p_system_langCode_e]}}
                </div>
                <tq-more-info :p_more-info-id_uid="enum_moreInfoIds_s.helpers_event_store_link"
                              :p_img_e="enum_moreInfoImgOptions_e.ass_img_info2_w"
                              class="TQ_width_24px TQ_verticalAlignMiddle TQ_grid_center TQ_textColor_black"></tq-more-info>
            </div>

            <div class="TQ_text_selectable TQ_direction_ltr TQ_borderRadius TQ_border TQ_box_shadow TQ_padding_8px TQ_align_initial TQ_text_14px TQ_margin_8px TQ_bg_gray4 TQ_selectable">
                {{co_storeLink_s}}
            </div>

            <div class="TQ_margin_8px">
                <div class="TQ_bg_gold TQ_textColor_white TQ_padding_4px TQ_box_shadow TQ_borderRadius TQ_inline TQ_center TQ_clickable" @click="m_copyStoreLink_f">
                    <tq-image :pb_src_r="ass_img_copy_w" class="TQ_width_20px TQ_verticalAlignMiddle TQ_padding_4px"/>
                    <div class="TQ_inline TQ_padding_4px">{{ass_strings.twoWords_copyLink[p_system_langCode_e]}}</div>
                </div>
            </div>

        </tq-popup>

    </div>
</template>

<script>
    import TqTable from "../../../../components/basic2/TqTable";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        FB_QuestTicket,
        FB_UserData,
        FB_QuestEvent,
        FB_QuestExplore,
        FB_Cost,
        FB_QuestTicket_History,
        FB_UserDataSub_CreditCard,
        FB_UserDataSub_SubscriptionPlanInfo,
        FB_UDS_CreatorMonthlyTickets, FB_QuestBody
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {
        validator_arrayClass_fb,
        validator_enum_fb,
        validator_number_fb,
        validator_objClass_fb
    } from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_langCodes,
        enum_accessLevelOptions,
        enum_questTicketStatus,
        enum_costCurrency_n,
        enum_questTicketActions,
        enum_moreInfo_helpersIds_s,
        enum_moveToOptions,
        enum_urlParams,
        enum_minMonthlySlotsTicketsPricing,
        enum_inputType,
        enum_moreInfoImgOptions_e, enum_subPlan_players, enum_subscriptionPlanMax_playersInTeams
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {
        format_cost_s,
        format_costCurrency,
        format_date_YYYY_MM_DD_fs, format_ticketStatus_fs
    } from "../../../../../functions/src/shareCode/Share_S_Format";
    import {obj_size_fn} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {
        helper_copyStringToClipboard,
        helper_getTicketStatusClass_fs,
        helper_getTicketUrl
    } from "@/scripts/S_Helper";
    import {notification_notify, notification_notify2} from "@/scripts/S_Notification";
    import TqPopup from "../../../../components/basic/TqPopup";
    import {
        ass_img_checked_w,
        ass_img_copy_w,
        ass_img_edit_w,
        ass_img_link_w,
        ass_img_ticket_w,
        ass_img_xLetter_w,
        ass_svg_photo_w
    } from "@/assets/scripts/Ass_Files";
    import TqTextarea from "../../../../components/basic/TqTextarea";
    import TqDropdown from "../../../../components/basic/TqDropdown";
    import {date_getNowDate_resetSeconds_fd, date_newDate_fd} from "@/scripts/S_Date";
    import TqLoaderButton from "../../../../components/basic2/TqLoaderButton";
    import TqImage from "@/components/basic/TqImage";
    import {gv_urls} from "@/scripts/S_GlobalVar";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import {
        server_creatorRequestTicket_f,
        serverPre_subUserData_creditCards_cl_remove_f,
        serverPre_subUserData_creditCards_cl_set_f, serverPre_updateTicket_f,
    } from "@/scripts/Server/S_ServerPre";
    import FcErrorInput from "@/components/basic/TqErrorInput";
import { route_openNewTab_f } from "@/router";
import { DataHooks_o } from "@/scripts/S_DataHooks";

    export default {
        name: "c_Creator_Events_Item_Tickets",
        components: {
            FcErrorInput,
            TqMoreInfo, TqImage, TqLoaderButton, TqDropdown, TqTextarea,  TqPopup, TqTable},
        props:{
            p_questExplore_c:{
                type: FB_QuestExplore,
                require: true
            },
            p_questBody_c:{
                type: FB_QuestBody,
                require: true
            },
            p_currentUserData_c:{
                type: FB_UserData,
                require: true
            },
            p_subPlanInfo_c:{
                type: FB_UserDataSub_SubscriptionPlanInfo,
                require: true
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_questTickets_ac : {
                type: Array,
                require: true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestTicket)
                }
            },
            p_usersData_byUserId_c:{
                type: Object,
                require: true,
                validator(obj){
                    return validator_objClass_fb(obj, FB_UserData)
                }
            },
            p_questEvent_c:{
                type: FB_QuestEvent,
                require: true,
            },
            p_creatorMonthlyTickets_c:{
                type: FB_UDS_CreatorMonthlyTickets,
                require: true,
            },

            pe_route_openNewWindow_f:{
                type: Function,
                require: true,
            },
            pe_server_creatorRequestTicket_f:{
                type: Function,
                require: true,
            }

        },
        data(){
            return {

                popup_showStoreLink_vb : {val : false},
                editTicketPopup_o : {
                    showPopup_vb    : {val : false},
                    showLoader_b    : false,
                    editTicket_c    : null,
                    spots_n         : 1,
                    cost_c          : new FB_Cost({c_value_n : 0}),
                    text_s          : '',
                },

                // server
                server_uds_creditCards_byId_c: {},

                // imports
                ass_strings : ass_strings,
                enum_moreInfoImgOptions_e : enum_moreInfoImgOptions_e,
                enum_moreInfoIds_s : enum_moreInfo_helpersIds_s,
                enum_costCurrency : enum_costCurrency_n,
                enum_inputType : enum_inputType,
                DataHooks_o,
                format_ticketStatus_fs : format_ticketStatus_fs,
                format_costCurrency : format_costCurrency,
                format_date_YYYY_MM_DD_fs : format_date_YYYY_MM_DD_fs,
                format_cost_s : format_cost_s,
                obj_size_fn : obj_size_fn,
                helper_getTicketStatusClass_fs : helper_getTicketStatusClass_fs,
                ass_img_ticket_w : ass_img_ticket_w,
                ass_img_link_w : ass_img_link_w,
                ass_img_copy_w : ass_img_copy_w,
                ass_img_xLetter_w : ass_img_xLetter_w,
                ass_img_checked_w : ass_img_checked_w,
                ass_img_edit_w : ass_img_edit_w,
                ass_svg_photo_w,
            }
        },
        computed:{
            co_storeLink_s(){

                if(this.p_questEvent_c == null){
                    return ''
                }

                return `${gv_urls.tq_basicUrl}/${this.p_system_langCode_e}/${enum_moveToOptions.player_store_quest.substring(1)}/${this.p_questEvent_c.qev_questId_uid}?${enum_urlParams.eventId}=${this.p_questEvent_c.qev_eventId_uid}`
                },
            co_totalAvailableTickets_n(){
                let ans =this.p_subPlanInfo_c.udsspi_maxPlayers_n - this.p_creatorMonthlyTickets_c.udscmt_totalSpots_n

                if(this.editTicketPopup_o.editTicket_c){
                    ans += this.editTicketPopup_o.editTicket_c.qt_spots_n
                }

                return ans
            },
            co_editTicket_error_cost_s(){
                // negative number
                if(!validator_number_fb(this.editTicketPopup_o.cost_c.c_value_n) || this.editTicketPopup_o.cost_c.c_value_n<0){
                    return ass_strings.threeWords_onlyPositiveNumbers[this.p_system_langCode_e]
                }

                return null
            },
            co_editTicket_error_slots_s(){
                // negative number
                if(!validator_number_fb(this.editTicketPopup_o.spots_n) || this.editTicketPopup_o.spots_n<0){
                    return ass_strings.threeWords_onlyPositiveNumbers[this.p_system_langCode_e]
                }

                let totalCreatedTicketsSlots_n = this.p_creatorMonthlyTickets_c.udscmt_totalSpots_n

                // edit existing ticket
                if(this.editTicketPopup_o.editTicket_c){
                    if (this.editTicketPopup_o.spots_n < this.editTicketPopup_o.editTicket_c.qt_m_joinedPlayersNum_fn()) {
                        return ass_strings.fourWords_smallerThanJoinedPlayers[this.p_system_langCode_e]
                    }
                    totalCreatedTicketsSlots_n -= this.editTicketPopup_o.editTicket_c.qt_spots_n
                }

                if(this.editTicketPopup_o.spots_n + totalCreatedTicketsSlots_n> this.p_subPlanInfo_c.udsspi_maxPlayers_n){
                    return ass_strings.threeWords_maxEventTickets[this.p_system_langCode_e]
                }

                return null
            },
        },
        methods:{

            m_openMediaInAnewTab_f(){

                if(this.p_questTickets_ac.length == 0){
                    notification_notify2({
                        title_s : ass_strings.oneWord_error,
                        text_s: ass_strings.fourWords_pleaseCreateATicket
                    })
                    return;
                }

                const ticketId_uid =  this.p_questTickets_ac[0].qt_ticketId_uid
                route_openNewTab_f(this.p_system_langCode_e, enum_moveToOptions.standAlong_questMedia + "/" + ticketId_uid)
            },
            // dom
            m_dom_getAvatar_s(userId_uid){

                let userData_c = this.p_usersData_byUserId_c[userId_uid]

                if(userData_c == null)
                    return null

                return userData_c.ud_avatar_c
            },
            m_dom_displayCancelBtn_fb(questTicket_c){
                return  questTicket_c.qt_purchasedBy_e === enum_accessLevelOptions.player &&
                    [enum_questTicketStatus.waitingToApprove, enum_questTicketStatus.approved, enum_questTicketStatus.creatorRequest, enum_questTicketStatus.creatorRequestApproved].includes(questTicket_c.qt_status_e)
            },
            m_dom_displayApprovedBtn_fb(questTicket_c){
                return questTicket_c.qt_purchasedBy_e === enum_accessLevelOptions.player &&
                    [enum_questTicketStatus.waitingToApprove].includes(questTicket_c.qt_status_e)
            },
            m_dom_displayEditBtn_fb(questTicket_c){
                let now_d = new Date()

                let ticketEditableDate_start_d = new Date(questTicket_c.qt_saleDate_t)
                ticketEditableDate_start_d.setDate(1)
                ticketEditableDate_start_d.setHours(0)
                ticketEditableDate_start_d.setMinutes(0)
                ticketEditableDate_start_d.setSeconds(1)

                let saleMonth_n = new Date(questTicket_c.qt_saleDate_t).getMonth()
                let ticketEditableDate_end_d = new Date(questTicket_c.qt_saleDate_t)
                ticketEditableDate_end_d.setMonth(saleMonth_n+1)
                ticketEditableDate_end_d.setDate(9)
                ticketEditableDate_end_d.setHours(0)
                ticketEditableDate_end_d.setMinutes(0)
                ticketEditableDate_end_d.setSeconds(1)

                return questTicket_c.qt_purchasedBy_e === enum_accessLevelOptions.creator && questTicket_c.qt_m_canEdit_fb()
            },

            // user events
            m_userEvent_copyWebTicketUrl(questTicket_c){
                let link = helper_getTicketUrl(questTicket_c.qt_ticketId_uid)
                helper_copyStringToClipboard(link)
                notification_notify(ass_strings.twoWords_copiedLink)
            },
            m_userEvent_approveTicket(questTicket_c){

                questTicket_c.qt_status_e = enum_questTicketStatus.approved;
                questTicket_c.qt_history_ac.push(new FB_QuestTicket_History({
                    qth_timestamp_t     : date_newDate_fd().getTime(),
                    qth_actions_e       : enum_questTicketActions.approve,
                }))

                serverPre_updateTicket_f(questTicket_c, questTicket_c.qt_spots_n).then( () =>{
                    notification_notify(ass_strings.oneWord_creator, ass_strings.twoWords_approveTicket)
                })
            },
            m_userEvent_editTicket(questTicket_c){
                this.editTicketPopup_o.showPopup_vb.val = true
                this.editTicketPopup_o.editTicket_c = questTicket_c
                this.editTicketPopup_o.spots_n = questTicket_c.qt_spots_n
                this.editTicketPopup_o.cost_c = questTicket_c.qt_cost_c
                this.editTicketPopup_o.text_s = questTicket_c.qt_creatorText_s

            },
            m_userEvent_cancelTicket(questTicket_c){

                questTicket_c.qt_status_e = enum_questTicketStatus.canceled;
                questTicket_c.qt_history_ac.push(new FB_QuestTicket_History({
                    qth_timestamp_t     : date_newDate_fd().getTime(),
                    qth_actions_e       : enum_questTicketActions.cancel,
                }))


                serverPre_updateTicket_f(questTicket_c, questTicket_c.qt_spots_n).then(() =>{
                    notification_notify(ass_strings.oneWord_creator, ass_strings.twoWords_cancelTicket)
                })
            },
            m_userEvent_openReceipt_f(questTicket){
                this.pe_route_openNewWindow_f(questTicket.qt_receiptLink_s)
            },
            m_userEvent_showPopup_requestNewTicket_f(){

                if(this.editTicketPopup_o.editTicket_c){
                    this.m_refreshEditTicket_f()
                }

                this.editTicketPopup_o.showPopup_vb.val = true

            },
            m_userEvent_approveEditTicket_f(){
                if(this.co_editTicket_error_cost_s || this.co_editTicket_error_slots_s){
                    return
                }

                //  update ticket
                if(this.editTicketPopup_o.editTicket_c){

                    if(this.editTicketPopup_o.spots_n < this.editTicketPopup_o.editTicket_c.qt_m_joinedPlayersNum_fn()){
                        notification_notify(ass_strings.oneWord_notice, ass_strings.fourWords_pleaseFillAllFields)
                        return
                    }

                    let spotsGap_n = this.editTicketPopup_o.spots_n -  this.editTicketPopup_o.editTicket_c.qt_spots_n
                    this.editTicketPopup_o.editTicket_c.qt_spots_n = this.editTicketPopup_o.spots_n
                    this.editTicketPopup_o.editTicket_c.qt_cost_c = this.editTicketPopup_o.cost_c
                    this.editTicketPopup_o.editTicket_c.qt_creatorText_s = this.editTicketPopup_o.text_s

                    this.editTicketPopup_o.showLoader_b = true
                    serverPre_updateTicket_f(this.editTicketPopup_o.editTicket_c, spotsGap_n).then(() => {
                        this.m_refreshEditTicket_f()
                    })
                    // create new ticket
                }else{

                    let newQuestTicket_c = new FB_QuestTicket({
                        qt_ticketId_uid         : null,
                        qt_shortKeyId_s         : this.p_questExplore_c.qex_shortKeyPrefixId_s,
                        qt_questId_uid          : this.p_questExplore_c.qex_questId_uid,
                        qt_questType_e          : this.p_questExplore_c.qex_questType_e,
                        qt_creatorId_uid        : this.p_questExplore_c.qex_creatorId_uid,

                        qt_eventId_uid          : this.p_questEvent_c.qev_eventId_uid ,
                        qt_eventStartingDate_t  : this.p_questEvent_c.qev_startingDate_t,

                        qt_playerId_uid        : this.p_currentUserData_c.ud_userId_uid,

                        qt_playersJoinDate_byUserId_t   : {},
                        qt_saleDate_t                   : date_getNowDate_resetSeconds_fd().getTime(),
                        qt_purchasedBy_e                : enum_accessLevelOptions.creator,

                        qt_status_e : enum_questTicketStatus.approved,
                        qt_history_ac : [new FB_QuestTicket_History({
                            qth_timestamp_t : (date_getNowDate_resetSeconds_fd()).getTime(),
                            qth_actions_e : enum_questTicketActions.approve
                        })],

                        qt_spots_n : this.editTicketPopup_o.spots_n,
                        qt_cost_c : this.editTicketPopup_o.cost_c,
                        qt_creatorText_s : this.editTicketPopup_o.text_s,
                    })

                    this.editTicketPopup_o.showLoader_b = true

                    server_creatorRequestTicket_f(newQuestTicket_c).then(() => {
                        this.m_refreshEditTicket_f()
                    })
                }

            },

            // helpers
            m_copyStoreLink_f(){
                helper_copyStringToClipboard(this.co_storeLink_s)
                notification_notify2({title_s: ass_strings.threeWords_copiedToClipboard[this.p_system_langCode_e]})
            },
            m_refreshEditTicket_f(){
                this.editTicketPopup_o = {
                    showPopup_vb    :  {val : false},
                    showLoader_b   :  false,
                    spots_n : 1,
                    cost_c :  new FB_Cost({c_value_n : 0}),
                    text_s :  '',
                }
            },
        },
        created(){


            // 2) valueListener user creditCards info
            serverPre_subUserData_creditCards_cl_set_f({
                viewName_s: this.$options.name,
                userId_uid : this.p_currentUserData_c.ud_userId_uid,
                cb_f : (uds_creditCards_c)=> {
                    if(uds_creditCards_c){
                        this.$set(this.server_uds_creditCards_byId_c, uds_creditCards_c.udscc_m_id_s(), uds_creditCards_c)
                    }

                }
            })

            // test
            let ans_o = []
            this.p_questTickets_ac.forEach((questTicket_c, index) => {
                ans_o.push(`https://TravelQuest.xyz/iw/entry-ticket?ticketId=${questTicket_c.qt_ticketId_uid}`)
            })


        },
        destroyed(){
            serverPre_subUserData_creditCards_cl_remove_f({viewName_s: this.$options.name, userId_uid: this.$options.name})
        }
    }
</script>

<style scoped>

</style>